import React from "react";
import { Checkbox } from "antd";
import { StyleSheet, Text } from "../../platformComponents";
import { colors, alignItems, flexDirection, fontSize, margin } from "../../styles/common";
import { TCommonCheckboxProps } from "@adgm/cross-models";

export const CommonCheckbox: React.FC<TCommonCheckboxProps> = ({
  value,
  checked,
  label,
  onChange,
  children
}) => {
  return (
    <div style={styles.checkbox}>
      <Checkbox
        style={{marginRight: margin.m8}}
        checked={checked}
        onChange={e => {
          onChange?.(e.target.value);
        }}
        value={value}>
      </Checkbox>
      {children ?? <Text style={styles.text}>{label}</Text>}
    </div>
  );
};

export default CommonCheckbox;
const styles = StyleSheet.create({
  checkbox: {
    display: "flex",
    flexDirection: flexDirection.row,
    alignItems: alignItems.center,
  },
  text: {
    flex:1,
    fontSize: fontSize.f16,
    fontFamily: "Common-Regular",
    color: colors.white,
  },
});
